import React from 'react';
import { useParams, useSearchParams } from 'react-router';
import { CurriculumPageContent } from '../../../curriculum/CurriculumPage';

/**
 * CurriculumPageWrapper - Wraps CurriculumPageContent for use in React Router
 * Uses the content component directly since QueryClientProvider is already provided by App
 */
export const CurriculumPageWrapper = () => {
  const { childId } = useParams();
  const [searchParams] = useSearchParams();

  // Get flash messages from URL params (set after redirects)
  const flashNotice = searchParams.get('notice');
  const flashAlert = searchParams.get('alert');

  // Build new activity path for React Router (relative to /dashboard)
  const newActivityPath = `/children/${childId}/activities/new`;

  return (
    <CurriculumPageContent
      childId={childId}
      flashNotice={flashNotice}
      flashAlert={flashAlert}
      newActivityPath={newActivityPath}
    />
  );
};

export default CurriculumPageWrapper;
